export const SDK_VERSION = '7.88.0';
